export const getEntryData = (id?: string, data?: Service) => data?.includes.Entry.find((item) => item.sys.id === id)
